import { makeStyles, withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

export const useStyles = makeStyles(theme => ({
  heading: {
    fontSize: '24px',
    lineHeight: '32px',
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
  subheading: {
    display: 'block',
    fontSize: '16px',
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  periodHeading: {
    fontWeight: '600',
    marginBottom: '10px',
    display: 'inline-block',
  },
  availableTimesWrapped: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: '36px',
  },
  datePickerStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '40px 0 20px',
  },
  timeSlotStyles: {
    marginTop: '24px',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
  },
  overrideDescription: {
    [theme.breakpoints.up('md')]: {
      order: 3,
    },
    '& button': {
      paddingLeft: 0,
    },
  },
  warnWrapper: {
    background: theme.palette.primary.selected,
    padding: '24px 16px 24px 16px',
    [theme.breakpoints.only('xs')]: {
      padding: '16px 0px 16px 16px',
    },
  },
  dialogActions: {
    margin: '32px 8px 24px 0px',
    [theme.breakpoints.only('xs')]: {
      margin: '8px 8px 8px 0px',
    },
    justifyContent: 'flex-end',
  },
  calendarPng: {
    width: '100px',
    height: '100px',
  },
  adornedEnd: {
    '& button': {
      padding: 0,
    },
  },
}))

export const TimeSlotButton = withStyles(theme => ({
  root: {
    height: 'initial',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '24px',
    padding: '6px 16px',
    borderRadius: '4px',
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    margin: theme.spacing(0.5),
    flexShrink: '0',
    backgroundColor: '#ffffff',
  },
  contained: {
    boxShadow: theme.shadows[2],
    border: '1px solid transparent',
  },
}))(Button)
